import React, { useEffect } from 'react';
import './ConfirmDialog.css';

const VARIANT_CONFIG = {
  danger: {
    icon: 'fa-trash-can',
    buttonClass: 'btn btn-danger',
  },
  warning: {
    icon: 'fa-triangle-exclamation',
    buttonClass: 'btn btn-primary',
  },
  info: {
    icon: 'fa-circle-info',
    buttonClass: 'btn btn-primary',
  },
};

const ConfirmDialog = ({
  open,
  title = 'Confirmar ação',
  message,
  confirmLabel = 'Confirmar',
  cancelLabel = 'Cancelar',
  variant = 'warning',
  loading = false,
  onConfirm,
  onCancel,
}) => {
  useEffect(() => {
    if (!open) return undefined;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    const handleKeyDown = (event) => {
      if (event.key === 'Escape' && !loading) {
        onCancel?.();
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [open, loading, onCancel]);

  if (!open) return null;

  const config = VARIANT_CONFIG[variant] || VARIANT_CONFIG.warning;

  return (
    <div
      className="confirm-dialog-overlay"
      onClick={() => !loading && onCancel?.()}
      role="presentation"
    >
      <div
        className={`confirm-dialog confirm-dialog--${variant}`}
        role="dialog"
        aria-modal="true"
        aria-labelledby="confirm-dialog-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="confirm-dialog__icon" aria-hidden="true">
          <i className={`fa-solid ${config.icon}`}></i>
        </div>

        <div className="confirm-dialog__content">
          <h3 id="confirm-dialog-title" className="confirm-dialog__title">
            {title}
          </h3>
          <p className="confirm-dialog__message">{message}</p>
        </div>

        <div className="confirm-dialog__actions">
          <button
            type="button"
            className="btn btn-secondary confirm-dialog__button"
            onClick={onCancel}
            disabled={loading}
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            className={`${config.buttonClass} confirm-dialog__button`}
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? (
              <>
                <i className="fa-solid fa-spinner fa-spin"></i>
                Processando...
              </>
            ) : (
              <>
                <i className={`fa-solid ${config.icon}`}></i>
                {confirmLabel}
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
